/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_AgentInputs */

const cs_filter_agent = /** @type {(inputs: Filter_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiřazený makléř`)
};

const en_filter_agent = /** @type {(inputs: Filter_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned agent`)
};

/**
* | output |
* | --- |
* | "Assigned agent" |
*
* @param {Filter_AgentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_agent = /** @type {((inputs?: Filter_AgentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_AgentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_agent(inputs)
	return cs_filter_agent(inputs)
});